import { Widget } from '@sprinklr/stories/widget/Widget';

export var WidgetHyperlinkButton: Widget = {
    type: 'hyperlinkButton',
    id: 'hyperlink-button',
    name: 'Hyperlink Button',
    position: {
        grid: {
            enabled: true,
            columns: {
                start: 4,
                end: 8,
            },
            rows: {
                start: 2,
                end: 3,
            },
        },
    },
    options: {
        url: 'https://www.yourlink.com',
        slideNumber: 1,
        text: 'Click Here',
        fontSize: 40,
        buttonBorder: {
            enabled: false,
            radius: 15,
        },
        font: {},
    },
};
